export const COURSE_PRODUCT_ROUTE_KEYS = [
  'courses-products',
  'courses-products-modules-lessons',
  'courses-products-live-sessions',
  'courses-purchase-product',
  'courses-checkout',
] as const

const courseProductRouteKeySet = new Set<string>(COURSE_PRODUCT_ROUTE_KEYS)
const liveSessionsPathPattern = /\/live-sessions\/?$/

export interface CourseChildRouteSource {
  path?: string
  params?: Record<string, unknown>
}

export function isCourseProductRouteKey(key: string | null | undefined): boolean {
  return typeof key === 'string' && courseProductRouteKeySet.has(key)
}

export function isCourseChildRoute(route: CourseChildRouteSource): boolean {
  const lessonId = route.params?.lessonId
  const postId = route.params?.postId
  const hasChildId = (typeof lessonId === 'string' && lessonId.length > 0) || (typeof postId === 'string' && postId.length > 0)

  return hasChildId || (typeof route.path === 'string' && liveSessionsPathPattern.test(route.path))
}
